import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CodaltComponent } from 'src/app/codalt.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LocalStorage } from 'src/app/storage.class';
import { PasswordRequestValidationState } from './validation-state.enum';

@Component({
    selector: 'app-restore-password',
    templateUrl: './restore-password.component.html',
    styleUrls: ['./restore-password.component.scss'],
    standalone: false,
})
export class RestorePasswordComponent extends CodaltComponent implements OnInit {
    public ValidationState = PasswordRequestValidationState;
    public form: FormGroup;
    public message;
    public validToken: PasswordRequestValidationState = PasswordRequestValidationState.Validating;
    public loading = false;
    private token: string;

    constructor(
        private route: ActivatedRoute,
        private authService: AuthService
    ) {
        super();
    }

    ngOnInit() {
        LocalStorage.logoutUser();

        this.form = new FormGroup({
            password: new FormControl('', [
                Validators.required,
                Validators.minLength(7),
                this.passwordStrengthValidator,
            ]),
            passwordconf: new FormControl('', [Validators.required, this.matchFieldValidator('password')]),
        });
        this.subscriptions.add(
            this.form
                .get('password')
                .valueChanges.subscribe(() => this.form.controls['passwordconf'].updateValueAndValidity())
        );
        this.subscriptions.add(
            this.route.params.subscribe(params => {
                this.token = params['token'];
                this.authService.verifyResetToken(this.token).subscribe({
                    next: () => (this.validToken = PasswordRequestValidationState.Valid),
                    error: () => (this.validToken = PasswordRequestValidationState.Invalid),
                });
            })
        );
    }

    passwordStrengthValidator(control: AbstractControl): ValidationErrors | null {
        const pattern = /^(?=.*[!@#$&*0-9A-Z].*[!@#$&*0-9A-Z]).*$/;
        return pattern.test(control.value) ? null : { weakPassword: true };
    }

    matchFieldValidator(matchField: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const equal = this.form?.controls[matchField].value === control.value;
            return equal ? null : { matchField: true };
        };
    }

    setNewPassword() {
        if (this.form.valid) {
            this.loading = true;
            this.authService.restorePassword(this.token, this.form.value.password).subscribe(
                authResponse => {
                    this.loading = false;
                    LocalStorage.setUserToken(authResponse.access_token);
                    LocalStorage.setUser(authResponse.user);
                    this.authService.redirectAfterLogin();
                },
                response => {
                    this.loading = false;
                    if (response['error']['status'] === 0) {
                        this.message = 'Kon de server niet bereiken';
                    } else {
                        this.message = response['error']['error']['errormessage'] || response['error']['errormessage'];
                    }
                }
            );
        }
    }
}
